export const pxToRem = (nb: number) => {
    const base = 16

    return `${nb / base}rem`
}

